module.exports = __webpack_public_path__ + "img/stellenbosch-fc.0e78151e.png";